
import React, { Component } from 'react';
import '../login/styles.css';
import { Form } from 'react-bootstrap';
import favicon from '../../assets/images/Sysco_Logo.png';
import { store } from '../..';
import { PORTAL_MESSAGE, PORTAL_OUTAGE_MESSAGE } from '../../store/actions/actionTypes';
import { connect } from 'react-redux';
import cookie from 'react-cookies';
import moment from 'moment';
import {
  INCORRECT_MESSAGE, UNAUTHORIZED_MESSAGE, NETWORK_ERROR, INACTIVEVENDOR_MESSAGE,
  LOGIN_TYPE, LOGIN_SSS_SUPPLIER, LOGIN_SSS_COLLEAGUE,
  USER_NOT_ASSIGNED_TO_GROUP,
  FORBIDDEN_MESSAGE,
  COLLEAGUE_USER_TYPE
} from '../../config/string';
import { authSss } from '../../store/actions/loginAction';
import { Button, Select, Spin } from 'antd';
import { LoginOutlined, PlayCircleTwoTone } from '@ant-design/icons';
import { toast } from 'react-toastify';
import Axios from 'axios';
import { environment } from '../../common/sysco-ui-components/config/constant';
import { SUPPLIER_SUITE_URL } from '../../common/sysco-ui-components/config/constant';
import { getOutageMessagesUIComponent } from '../../common/sysco-ui-components/utils/common';
import { SUPPLIER_PATH } from '../../config/path';

const { Option } = Select;

class VendorLogin extends Component {
  static displayName = 'VendorLogin';

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: '',
      unauth: false,
      serviceFailed: false,
      inactiveVendor: false,
      loading: false,
      accountLocked: false,
      rmeNumber: null,
      userEmail: null,
      vendorNumbers: [],
      vendorNumbersLoading: true,
      outageMassages: null,
      authorizationCode: null,
      groupNotFound: false,
      forbidden: false,
      userType: null
    }
  }

  getUserEmail = () => {
    if (this.state.userType === COLLEAGUE_USER_TYPE || localStorage.getItem("userType") === COLLEAGUE_USER_TYPE) {
      this.getColleagueUserInfo()
        .then(this.handleUserInfo)
        .catch(err => {
          console.log('Error getting user email.', err)
          this.redirectToSupplierSuite();
        });
    } else {
      this.getCognitoUserInfo()
        .then(this.handleUserInfo)
        .catch(err => {
          console.log('Error getting user email.', err)
          this.redirectToSupplierSuite();
        });
    }
  }

  handleUserInfo = (userInfo) => {
    if (!userInfo || !userInfo.email) {
      throw new Error('Invalid user info');
    }

    const email = userInfo.email;
    this.setState({ userEmail: email });
    this.getVendorNumbers(email);
  };

  getColleagueUserInfo = async () => {
    try {
      const response = await Axios.get('/otds/user-info', {});

      if (!response || !response.data) {
        throw new Error('Invalid OTDS user info response');
      }

      const userInfo = response.data;
      localStorage.setItem("userType", COLLEAGUE_USER_TYPE);
      
      if (userInfo.email) {
        cookie.save('userEmail', userInfo.email, {
          path: '/',
        });
      }
      return userInfo;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        this.setState({ groupNotFound: true });
      }
      if (error.response && error.response.status === 403) {
        this.setState({ forbidden: true });
      }
      console.log('Error getting colleague user info.');
      this.setState({ vendorNumbersLoading: false });
      throw error;
    }
  }

  getVendorNumbers = (email) => {
    Axios({
      url: `${SUPPLIER_PATH}/get-vendor-numbers`,
      method: "GET",
      params: {
        "email": email
      }
    }).then(response => {
      if (response.data.groups) {
        let vendors = response.data.groups.map(group => group.rme_vendor_numbers).flat();
        vendors = [...new Set(vendors)];
        vendors.sort((a, b) => parseInt(a) - parseInt(b));
        this.setState({ vendorNumbers: vendors })
        if (vendors.length === 1) {
          this.setState({ rmeNumber: vendors[0] })
          cookie.save("changeVendorNumbers", false, {
            path: "/",
          });
        }
        else
          cookie.save("changeVendorNumbers", true, {
            path: "/",
          });
      }
      this.setState({ vendorNumbersLoading: false })
    }).catch(err => {
      console.log('Error getting vendor numbers.')
      this.setState({ vendorNumbersLoading: false })
    })
  }

  redirectToSupplierSuite = () => {
    let env = environment();
    if (env === "-dev")
      window.location.href = SUPPLIER_SUITE_URL.DEV;
    else if (env === "-stg")
      window.location.href = SUPPLIER_SUITE_URL.STG;
    else
      window.location.href = SUPPLIER_SUITE_URL.PRD;
  }

  getCognitoUserInfo = async () => {
    try {
      const response = await Axios.get('/cognito/user-info', {});
      const userInfo = response.data;

      if (userInfo.email) {
        cookie.save('userEmail', userInfo.email, {
          path: '/',
        });
      }
      return userInfo;
    } catch (error) {
      console.error('Error fetching user info:', error);
      throw error;
    }
  }

  componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    const landingPageUrl = window.location.origin + window.location.pathname;
    window.history.replaceState({}, document.title, landingPageUrl);

    this.setState({
      authorizationCode: queryParams.get('code'),
      userType: queryParams.get('user_type')
    });

    if (localStorage.getItem("userType") === COLLEAGUE_USER_TYPE) {
      cookie.save(LOGIN_TYPE, LOGIN_SSS_COLLEAGUE, {
        path: "/",
      });
    }else if(queryParams.get('user_type') === COLLEAGUE_USER_TYPE) {
      cookie.save(LOGIN_TYPE, LOGIN_SSS_COLLEAGUE, {
        path: "/",
      });
    } else {
      cookie.save(LOGIN_TYPE, LOGIN_SSS_SUPPLIER, {
        path: "/",
      });
    }
    toast.dismiss()
    store.dispatch({ type: PORTAL_MESSAGE })
    store.dispatch({ type: PORTAL_OUTAGE_MESSAGE })
    this.setState({ unauth: false })
    document.getElementById("headerMain").classList.add("loginclass");
    document.getElementById("antTab").classList.add("loginclass");
    setTimeout(this.getUserEmail, 3000);
  }

  componentWillUnmount() {
    document.getElementById("headerMain").classList.remove("loginclass");
    document.getElementById("antTab").classList.remove("loginclass");
  }

  componentWillReceiveProps = (newProps) => {
    this.setState({ loading: false })
    if (newProps.ctr.loginFailed)
      this.setState({ unauth: true });
    if (newProps.ctr.serviceFailed)
      this.setState({ serviceFailed: true });
    if (newProps.ctr.inactiveVendor)
      this.setState({ inactiveVendor: true });
    if (newProps.ctr.accountLocked)
      this.setState({ accountLocked: true });
    if (newProps.dashboardReducer.outageMsg)
      this.setState({ outageMassages: newProps.dashboardReducer.outageMsg });
  }

  loginAction = () => {
    if (!this.state.rmeNumber) {
      return
    }
    this.setState({ errorMsg: "", loading: true })
    let userName = this.state.rmeNumber;

    cookie.save("userName", userName, {
      path: "/",
    });
    localStorage.setItem("vendorNumber", userName)
    let errorMsg = '';
    this.setState({ errorMsg: errorMsg }, () => {
    });
    if (errorMsg.length === 0) {
      this.setState({ unauth: false });
      this.props.OnLogin(userName);
    } else
      this.setState({ loading: false })
  }

  handleRmeNumberChange = (value) => {
    this.setState({ rmeNumber: value });
  };

  render() {

    let errorDiv = null;
    if (this.state.errorMsg.length > 0)
      errorDiv = (<div className="errorMsg">{this.state.errorMsg}</div>);
    else if (this.state.loginFail)
      errorDiv = (<div className="errorMsg">{INCORRECT_MESSAGE}</div>);
    else if (this.state.unauth)
      errorDiv = (<div className="errorMsg">{UNAUTHORIZED_MESSAGE}</div>);
    else if (this.state.inactiveVendor)
      errorDiv = (<div className="errorMsg">{INACTIVEVENDOR_MESSAGE}</div>);
    else if (this.state.serviceFailed)
      errorDiv = (<div className="errorMsg">{NETWORK_ERROR}</div>);
    else if (this.state.forbidden)
      errorDiv = (<div className="errorMsg">{FORBIDDEN_MESSAGE}</div>);

    return (
      <div className="background-img" >

        <div className="loginBody">

          <div style={{ display: "inline-block" }}><div className="sysco_logo"><img className="head_img" src={favicon} alt="sysco" /><div style={{ float: "left" }}></div></div>
            <div className="spanT">SMS Supplier Payables </div></div>

          {this.state.groupNotFound &&
            getOutageMessagesUIComponent(USER_NOT_ASSIGNED_TO_GROUP, 0, () => this.setState({ groupNotFound: false }))}

          <div className="loginCard">
            {errorDiv}
            <div className="inputsSection">
              <Spin spinning={this.state.vendorNumbersLoading}>
                <Form id="loginForm">
                  {this.state.vendorNumbers.length === 1 ?
                    (<Select style={{ width: "100%" }} value={this.state.rmeNumber} disabled={true} />) :
                    (<Select showSearch style={{ width: "100%" }} placeholder="Select your Vendor Number" onChange={this.handleRmeNumberChange}>
                      {
                        this.state.vendorNumbers.map((item) => (
                          <Option key={item.id} value={item}>
                            {item}
                          </Option>
                        ))
                      }
                    </Select>)
                  }
                  <div >
                    <Button style={{ width: "100%", background: "#50b737", border: "#50b737" }} icon={<LoginOutlined />} loading={this.state.loading} disabled={!this.state.rmeNumber} type="primary" onClick={this.loginAction}>
                      SUBMIT
                    </Button>
                  </div>
                </Form>
              </Spin>
            </div>
          </div>
          <div className="loginMsg" >
            {this.state.outageMassages && this.state.outageMassages.map((msg, index) => (
              <div key={index}>
                <div className="subjectContainer" style={{ backgroundColor: msg.field_message_severity }}>
                  <span>{msg.title}</span>
                </div>
                <div className="messageContainer" dangerouslySetInnerHTML={{ __html: msg.body }}></div>
              </div>
            ))}
            <div style={{ backgroundColor: "rgb(12, 105, 160)", marginBottom: "5px", marginTop: "3px" }}>
              <div style={{ marginLeft: "10px" }}>Quick links</div>
            </div>
            <div style={{ display: "flex" }}>
              <div style={{ marginLeft: "10px", display: "flex", alignItems: "center" }}><PlayCircleTwoTone /><a href="https://view.vzaar.com/21463864/player" target="_blank" rel="noopener noreferrer" style={{ padding: "4px", color: "black" }}>Supplier Payables training video</a></div>

            </div>
            <div style={{ backgroundColor: "rgb(81, 186, 56)", marginBottom: "5px", marginTop: "10px" }}>
              <div style={{ marginLeft: "10px" }}>Message from SYSCO ({(this.props.dashboardReducer.loginMsg && this.props.dashboardReducer.loginMsg.lastModifiedDate) ? moment(this.props.dashboardReducer.loginMsg.lastModifiedDate).format("MM/DD/YYYY") : ""})</div>
            </div>
            <div style={{ marginLeft: "10px", color: "black", fontSize: "12px" }}>{this.props.dashboardReducer.loginMsg ? unescape(this.props.dashboardReducer.loginMsg.loginMessage) : ''}</div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    dashboardReducer: state.DashboardReducer,
    ctr: state.loginReducer
  };
}
const mapDispatchToProps = dispatch => {
  return {
    OnLogin: (username) => { dispatch(authSss(username)); }
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VendorLogin);